import { Component, Input, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { MatRippleModule } from '@angular/material/core';
import { NgFor, NgIf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

import { Need4SteelWizardService } from '../../../services/need4steel-wizard.service';
import { Need4SteelWizardStepperService } from '../../../services/need4steel-wizard-stepper.service';
import { Need4SteelWizardStep } from '../../../models/need4steel-wizard-state';

enum StepStatus {
	WIP = 0,
	WAIT = 1,
	DONE = 2
}

interface Need4SteelWizardStepper {
	num: number;
	labelTransId: string;
	status: StepStatus;
}

@Component({
	selector: 'copo-need4steel-wizard-stepper',
	templateUrl: './wizard-stepper.component.html',
	styleUrl: './wizard-stepper.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [NgFor, MatRippleModule, TranslateModule, MatIconModule, NgIf, MatButtonModule]
})
export class WizardStepperComponent implements OnDestroy {
	@Input() currentStep = 0;

	readonly WIP = StepStatus.WIP;
	readonly WAIT = StepStatus.WAIT;
	readonly DONE = StepStatus.DONE;

	steps: Need4SteelWizardStepper[] = [
		{
			num: 0,
			labelTransId: 'need4steel.wizard.stepper.step.product.specification',
			status: StepStatus.WIP
		},
		{
			num: 1,
			labelTransId: 'need4steel.wizard.stepper.step.summary',
			status: StepStatus.WAIT
		}
	];

	private readonly stepChangeSupscription: Subscription;

	constructor(
		private readonly need4steelStepperService: Need4SteelWizardStepperService,
		private readonly need4steelWizardService: Need4SteelWizardService
	) {
		this.stepChangeSupscription = this.need4steelStepperService.onStepChanged.subscribe({
			next: (result: { step: number }) => {
				this.currentStep = result.step;
				this.rearengeSteps();
			}
		});
	}

	ngOnDestroy() {
		this.stepChangeSupscription.unsubscribe();
	}

	nextStep() {
		this.currentStep += 1;
		this.rearengeSteps();
	}

	isSummaryStep() {
		return this.need4steelWizardService.getState().stepIndex === Need4SteelWizardStep.SUMMARY;
	}

	print() {
		print();
	}

	async onStepClick(stepClick: number) {
		await this.need4steelWizardService.actionMoveUsingSteps(stepClick);
	}

	private rearengeSteps() {
		this.processCurrentStep();
		this.processPriviousStep();
		this.processLeftSteps();
	}

	private processCurrentStep() {
		const currentStep = this.steps[this.currentStep];
		currentStep.status = StepStatus.WIP;
		this.steps[this.currentStep] = currentStep;
	}

	private processPriviousStep() {
		if (this.currentStep <= 0) {
			return;
		}
		for (let i = this.currentStep - 1; i >= 0; i--) {
			const previousStep = this.steps[i];
			previousStep.status = StepStatus.DONE;
			this.steps[i] = previousStep;
		}
	}

	private processLeftSteps() {
		if (this.currentStep === this.steps.length - 1) {
			return;
		}
		for (let i = this.currentStep + 1; i < this.steps.length; i++) {
			const leftStep = this.steps[i];
			leftStep.status = StepStatus.WAIT;
			this.steps[i] = leftStep;
		}
	}
}
